import type { ReactNode } from 'react';
import { customFor, useMediaVersion } from './media';

export default function Pic({ text, fallback, className }: { text: string; fallback: ReactNode; className?: string }) {
  useMediaVersion();
  const image = customFor(text)?.image;
  if (!image) return <>{fallback}</>;
  return <img className={`custom-pic${className ? ` ${className}` : ''}`} src={image} alt="" aria-hidden="true" draggable={false} />;
}
